export default __webpack_public_path__ + "static/media/medical_19.bf8a3441.jpg";